module.exports = __webpack_public_path__ + "media/student_v2/assets/images/add-cda05489fca6217ca72dd5c855b124d3.svg";